export const TOGGLE_COLLAPSE_SIDEBAR = 'TOGGLE_COLLAPSE_SIDEBAR';
export const COLLAPSE_OPEN_DRAWER = 'COLLAPSE_OPEN_DRAWER';
export const CHANGE_OPEN_KEYS = 'CHANGE_OPEN_KEYS';
export const SET_COLLAPSE_SIDEBAR = 'SET_COLLAPSE_SIDEBAR';
export const CLEAR_MENU = 'CLEAR_MENU';
export const DISPLAY_MOBILE_MENU = 'DISPLAY_MOBILE_MENU';
export const SELECTED_ITEM_MENU = 'SELECTED_ITEM_MENU';
export const TOGGLE_MOBILE_OVERLAY_MENU = 'TOGGLE_MOBILE_OVERLAY_MENU';
